import {useFetchData} from 'hooks/api/useFetchData'
import {CheckNeedEmployeeUpdate} from 'types/api/employees/checkNeedEmployeeUpdate'

export const useFetchCheckNeedEmployeeUpdate = (employeeId: string) => {
  const path = `/api/employees/${employeeId}/check_need_employee_updates`
  return useFetchData<CheckNeedEmployeeUpdate | undefined>(path, undefined, {})
}
